import MagazineItemPage from "./MagazineItemPage";

export default MagazineItemPage;
